import { CryptJsManager } from './../crypt-js/crypt-js-manager';
import { CryptJsSettingsInAutoAct } from './../../../constant/crypt-js-settings';
import { LogService } from './../log/log.service';
import { Observable } from 'rxjs';
import { BehaviorSubject, Subject, from } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MsgService } from '../../share/msg/msg.service';
import { SMILE9_ROLES, SMILE9_API_ENDPOINT, SKS_MASTER_API_ENDPOINT } from '../../../environments/environment';
import { Auth } from 'aws-amplify';
import * as MSG from '../../share/msg/msg';
import { AuthUserGroupOptions, Smile9UserSettings } from './auth-if';
import { CognitoErrorHandlerService } from '../../error/cognito-error-handler.service';
import { Condition } from '../../error/cognito-error-enums';
import { CONSTANT } from '../../../constant/constant';
const SMILE9_USER_SETTINGS = CONSTANT.SMILE9_USER_SETTINGS;
declare var $;

/** 認証処理・トークンやサインイン中の社員に関連する情報を保持し続けるためのService */
@Injectable()
export class AuthenticateService {
  /** サインイン中かどうかの判定フラグ */
  public loggedIn: BehaviorSubject<boolean>;
  /** サインイン成功時にtrueが流れるストリーム */
  public onSignInSucceeded = new Subject();
  /** サインアウト成功時にtrueが流れるストリーム */
  public onSignOutSucceeded = new Subject();
  /** モードON/OFF */
  mode = {
    firstPassSettingMode: false,
    forgotPassMode: false,
    inputCodeMode: false,
  };
  /** Cognitoで取得したユーザー情報 */
  cognitoUser: any;
  /** Cognitoで取得したトークン文字列 */
  token = '';
  ugId = '';
  ugName = '';
  role = '';
  serviceRole = '';

  /** 登録中のユーザーグループオプションを保持 */
  userGroupOptions: AuthUserGroupOptions[] = [];
  /** 登録中のSmile9ユーザー設定を保持 */
  smile9UserSettings: Smile9UserSettings[] = [];

  username = '';
  prefix = '';
  coCode = 0;
  coName = '';
  deptCode = 0;
  deptName = '';
  empCode = 0;
  empName = '';
  empStatus = 0;
  smile9Role = '';

  createPayrollKbn = '';
  hojoKbn = '';
  hojoGrpCode = 0;
  mainCafeCode = 0;
  guestReservationAuth = '';
  reducedTaxKbn = '';
  commentInRsv = '';
  multipleRsv = '';
  itadakimasuAteType = '';

  ip = '0.0.0.0';
  versionInToken = '';
  appClientName = '';
  /** 厨房予約端末かどうか */
  isKitchenRsvTerm = false;
  /** 非同期関数：一定時間経過後にサインアウト */
  timeoutSignOut;
  /** Guard前にユーザが入力したURL */
  inputUrl: string = null;
  /** Guard前にユーザが入力したURLのクエリパラメータ */
  inputUrlQueryParams: {key: string, value: string}[] = [];
  /** 対応可能な承認データかの判定 */
  actionEnabled = false;
  /** Load完了フラグ */
  isLoading = false;
  /** トークン認証中フラグ */
  isWaitAuthenticating = false;
  isRoleGuardNG = false;
  /** 利用中のアプリのバージョンが最新と異なった場合、app.componentにリロードを促すメッセージを表示する */
  isNewVersionAvailable = false;
  /** 印刷中フラグ */
  isPrinting = false;

  constructor(
    private http: HttpClient,
    private router: Router,
    private msgServ: MsgService,
    private logServ: LogService,
    private cognitoError: CognitoErrorHandlerService,
  ) {
    this.loggedIn = new BehaviorSubject<boolean>(false);
   }

  private checkIsItadakimasuTerm(smile9Id: string, smile9_role: string): boolean {
    if (smile9Id && smile9_role === SMILE9_ROLES.ITADAKIMASU) {
      console.log('localStorage.setItem ===> itadakimasu Smile9ID');
      localStorage.setItem('[AutoAct]Smile9ID', CryptJsManager.encrypt(smile9Id, CryptJsSettingsInAutoAct.KEY, CryptJsSettingsInAutoAct.IV));
      localStorage.setItem('[AutoAct]ugId', this.ugId);
      return true;
    } else {
      return false;
    }
  }

  /**
   * Cognitoユーザーのサインイン認証実施。各サインイン画面用Componentから呼び出される。
   * @param username ユーザー名
   * @param password パスワード
   */
  public signIn(username: string, password: string, smile9Id: string = null) {
    return new Promise(resolve => {
      this.isLoading = true;
      from(Auth.signIn(username, password)).pipe(
        tap(() => this.loggedIn.next(true))
      ).subscribe(
        async result => {
          // 仮パスワードでサインインした
          if (result.challengeName === 'NEW_PASSWORD_REQUIRED') {
            this.mode.firstPassSettingMode = true;
            this.cognitoUser = result;
          } else {
            // 本パスワードでサインインした
            // サインインページを記憶。ここで記憶したURLはリフレッシュトークン有効期限切れの際の強制遷移先となる。
            if (['/signin', '/card-signin', '/fsc-signin'].includes(location.pathname)) {
              localStorage.setItem('signInUrl', location.pathname);
              // サインインの度に、個人予約画面で使用するスクロール用sessionStorageを削除。
              sessionStorage.removeItem('rsvList-displayYearMonth');
              sessionStorage.removeItem('rsvList-dateToScroll');
            }
            await this.storeTokenInfoAsync(result);
            // カードサインインでいただきます画面へ遷移する場合は、localStorageにSmile9ID,ugIdを記憶しておく(自動処理に利用)
            this.checkIsItadakimasuTerm(smile9Id, this.smile9Role);
            this.checkToEnableAutoSignOut();

            // 元々ユーザが入力していたURLを保持していれば遷移
            this.checkUrlBeforeGuard();
          }
          this.msgServ.remove();
          this.isLoading = false;
          this.onSignInSucceeded.next(true);
          resolve(true);
        },
        err => {
          this.logServ.sendSigninLogAsync('ng', username, password);
          this.cognitoError.handleCognitoError(err.code, Condition.whenSignIn, err.message);
          this.isLoading = false;
          resolve(false);
        }
      );
    });
  }

  /** トークン認証失敗・権限不足によりサインイン画面へ強制遷移 */
  public jumpToLoginPage(): void {
    this.memorizeUrlInfo();
    this.removeTokenInfo();

    // サインイン時に記憶していたURLへ強制遷移。localStorageにURLが無い場合は/signinへ強制遷移。
    const signInUrl = localStorage.getItem('signInUrl');
    if (signInUrl) {
      this.router.navigate([signInUrl]);
    } else {
      this.router.navigate(['/signin']);
    }
  }

  /** ユーザがGuard直前に入力したURLを記憶 */
  private memorizeUrlInfo() {
    this.inputUrl = location.pathname;
    if (location.search) {
      const queryParamsArray = location.search.substring(1).split('&');
      queryParamsArray.forEach(param => {
        const keyAndValue = param.split('=');
        this.inputUrlQueryParams.push({
          key: keyAndValue[0],
          value: keyAndValue[1],
        });
      });
    }
  }

  /** Guardされる前のURLを記憶していた場合、そのURLへ遷移する */
  private checkUrlBeforeGuard() {
    if (this.inputUrl !== '' && this.inputUrl !== undefined && this.inputUrl !== null) {
      if (this.inputUrlQueryParams.length > 0) {
        const queryParams = {};
        this.inputUrlQueryParams.forEach(param => {
          queryParams[param.key] = decodeURI(param.value);
        });
        console.log(`navigate url before guard => ${this.inputUrl}, query: ${queryParams}`);
        this.router.navigate([this.inputUrl], { queryParams: queryParams, replaceUrl: true });
      } else {
        console.log(`navigate url before guard => ${this.inputUrl}`);
        this.router.navigateByUrl(this.inputUrl, { replaceUrl: true });
      }
    // 元々ユーザが入力していたURLを保持していない場合、ルートパスへ遷移
    } else {
      this.router.navigateByUrl('', { replaceUrl: true });
    }
    this.inputUrl = null;
    this.inputUrlQueryParams = [];
  }

  /**
   * Cognitoの最新ユーザー情報を取得する（localStorageのトークンは見ない）
   * @returns 取得結果
   */
  getLatestCurrentUserData(): Observable<any> {
    return from(Auth.currentAuthenticatedUser({bypassCache: true}));
  }

  /**
   * 現在有効なトークンを保持しているか判定。各ページ遷移前にauth.guard, role.guardで呼び出される。
   * @returns トークン保持していればtrue, そうでなければfalse
   */
  isAuthenticated(): Observable<boolean> {
    this.isWaitAuthenticating = true;

    return from(Auth.currentAuthenticatedUser()
    .then(token => this.storeTokenInfoAsync(token))
    .then(storeTokenOk => {
      // Smile9IDを保持している場合は、localStorageにSmile9ID, ugIdを記憶しておく(自動処理に利用)
      let smile9IdWithPrefix = localStorage.getItem('[AutoAct]Smile9ID');
      if (smile9IdWithPrefix) {
        smile9IdWithPrefix = CryptJsManager.decrypt(smile9IdWithPrefix, CryptJsSettingsInAutoAct.KEY, CryptJsSettingsInAutoAct.IV);
        this.checkIsItadakimasuTerm(smile9IdWithPrefix, this.smile9Role);
      }
      // 初回認証時のみサインインログを出力。初回認証であるかはsessionStorageで判定する
      const isCompletedInitAuth = sessionStorage.getItem('isCompletedInitAuth');
      if (isCompletedInitAuth !== 'true') {
        sessionStorage.setItem('isCompletedInitAuth', 'true');
        return this.logServ.sendSigninLogAsync('ok');
      }
      return new Promise(resolve => resolve(true));
    })
    .then(outputAuthLogOk => {
      this.isWaitAuthenticating = false;
      this.loggedIn.next(true);
      return true;
    })
    .catch(err => {
      console.error(err);
      this.isWaitAuthenticating = false;
      this.loggedIn.next(false);
      return false;
    }));
  }

  /**
   * サインアウトして、localStorageからCognitoのトークン情報を消去する。
   * @param option 'notNavigate'=サインアウト処理後にページ遷移しない。 'msg:cant-scan-card'=カードスキャン画面で有効な食堂機能が未設定だった時。
   */
  signOut(option: string = null): Promise<boolean> {
    return new Promise(resolve => {
      // token情報破棄前に判定用のプロパティを保持する
      const prefix = this.prefix;
      const isEnableAddPrefixToSmile9Id: boolean = this.isSetSmile9UserSettings(SMILE9_USER_SETTINGS.ADD_PREFIX_TO_SMILE9ID, '1');

      from(Auth.signOut()).subscribe(
        result => {
          this.removeTokenInfo();
          this.loggedIn.next(false);
          this.onSignOutSucceeded.next(true);
          if (option === 'notNavigate') {
            resolve(false);
            return;
          }
          // サインイン時に記憶していたURLへ強制遷移。localStorageにURLが無い場合は/signinへ強制遷移。
          const signInUrl = localStorage.getItem('signInUrl');
          // カードサインインへ戻る際にSmile9IDにprefix付与設定が有効なユーザーなら、クエリにprefix付与して戻る
          if (signInUrl === '/card-signin' && isEnableAddPrefixToSmile9Id) {
            this.router.navigate([signInUrl], { queryParams: { pre: prefix } });
          } else if (signInUrl) {
            this.router.navigate([signInUrl]);
          } else {
            this.router.navigate(['/signin']);
          }
          this.disableTimeoutSignOut();

          if (option === 'msg:cant-scan-card') {
            this.msgServ.warning(MSG.WARNING.REQUIRED_CAFE_FUNC_SETTINGS, '', 0);
          }
          resolve(true);
        },
        err => {
          this.cognitoError.handleCognitoError(err.code, Condition.whenSignOut, err.message);
          resolve(false);
        });
    });
  }

  /**
   * サインインユーザーのパスワードを変更
   * @param oldPassword 現在のパスワード
   * @param newPassword 新しいパスワード
   */
  changePassword(oldPassword: string, newPassword: string): void {
    Auth.currentAuthenticatedUser()
    .then(user => {
        return Auth.changePassword(user, oldPassword, newPassword);
    })
    .then(data => {
      this.msgServ.success(MSG.SUCCESS.CHANGE_PASSWORD, '');
    })
    .catch(err => {
      this.cognitoError.handleCognitoError(err.code, Condition.whenChangePassword, err.message);
    });
  }

  /**
   * 初回パスワード変更
   * @param temporaryPassword 一時パスワード
   * @param newPassword 本パスワード
   * @username ユーザー名
   */
  changePasswordFirst(temporaryPassword: string, newPassword: string, username: string): void {
    this.isLoading = true;

    // 長時間入力がなかった場合はセッション有効期限切れが発生するので、一度サインアウトする
    from(Auth.signOut()).subscribe(
      signOutResult => {
        this.removeTokenInfo();
        this.loggedIn.next(false);

        // 再サインイン
        from(Auth.signIn(username, temporaryPassword)).pipe(
          tap(() => this.loggedIn.next(true))
        ).subscribe(
          signInResult => {
            if (signInResult.challengeName === 'NEW_PASSWORD_REQUIRED') {
              this.mode.firstPassSettingMode = true;

              // 本パスワードを設定する
              Auth.completeNewPassword(signInResult, newPassword, {})
              .then(data => {
                // 本パスワード設定完了
                this.isLoading = false;
                this.router.navigate(['/']);
                this.msgServ.success(MSG.SUCCESS.CHANGE_PASSWORD, '');
                this.mode.firstPassSettingMode = false;
              })
              .catch(err => {
                this.cognitoError.handleCognitoError(err.code, Condition.whenCompleteNewPassword, err.message);
                this.isLoading = false;
              });
            }
          },
          err => {
            this.cognitoError.handleCognitoError(err.code, Condition.whenSignIn, err.message);
            this.isLoading = false;
            return;
          }
        );
      },
      err => {
        this.cognitoError.handleCognitoError(err.code, Condition.whenSignOut, err.message);
        this.isLoading = false;
        return;
    });
  }

  /**
   * パスワード再設定用の検証コードを送信
   * @param username ユーザー名
   */
  sendMailWithCode(username: string): void {
    this.isLoading = true;
    Auth.forgotPassword(username)
    .then(data => {
      this.mode.inputCodeMode = true;
      this.msgServ.success(MSG.SUCCESS.SEND_MAIL_FOR_CODE, '', 0);
      this.isLoading = false;
    })
    .catch(err => {
      this.cognitoError.handleCognitoError(err.code, Condition.whenForgotPassword, err.message);
      this.isLoading = false;
    });
  }

  /**
   * パスワードを忘れた際、新パスワードを設定。
   * @param username ユーザー名
   * @param code 検証コード
   * @param newPassword 新しいパスワード
   */
  forgotPasswordSubmit(username: string, code: string, newPassword: string): void {
    Auth.forgotPasswordSubmit(username, code, newPassword)
    .then(data => {
      this.msgServ.success(MSG.SUCCESS.CHANGE_PASSWORD, '');
      this.mode.inputCodeMode = false;
      this.mode.forgotPassMode = false;
    })
    .catch(err => {
      this.cognitoError.handleCognitoError(err.code, Condition.whenForgotPasswordSubmit, err.message);
    });
  }

  /**
   * Cognitoユーザーのメールアドレス更新リクエスト
   * @param mail メールアドレス
   */
  updateMail(mail: string): void {
    this.isLoading = true;
    /** ユーザのAttribute更新 */
    const AmazonCognitoIdentity = require('amazon-cognito-identity-js');
    const attributeList = [];
    const attr = {
        Name : 'email',
        Value : mail
    };
    const attribute = new AmazonCognitoIdentity.CognitoUserAttribute(attr);
    attributeList.push(attribute);
    this.cognitoUser.updateAttributes(attributeList, (err, result2) => {
      this.isLoading = false;
      if (err) {
          this.cognitoError.handleCognitoError(err['code'], Condition.whenUpdateAttributes, err.message);
          return;
      }
      this.msgServ.success(MSG.SUCCESS.SEND_MAIL_FOR_CODE, '', 0);
    });
  }

  /**
   * Cognitoユーザーのメールアドレスの更新を実施
   * @param verifyCode 検証コード
   * @returns 更新成功時にtrue
   */
  verifyNewMail(verifyCode: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.isLoading = true;
      /** 指定ユーザの新メールアドレス検証 */
      this.cognitoUser.verifyAttribute('email', verifyCode, {
        onSuccess: () => {
          this.msgServ.success(MSG.SUCCESS.CHANGE_MAIL, '');
          this.isLoading = false;
          resolve(true);
        },
        onFailure: err => {
          this.cognitoError.handleCognitoError(err['code'], Condition.whenForgotPasswordSubmit, err.message);
          this.isLoading = false;
          reject();
        }
      });
    });
  }

  /**
   * トークン情報をserviceのプロパティに格納
   * @param result Cognito認証成功時のレスポンス(Cognitoユーザー情報)
   */
  public async storeTokenInfoAsync(result: any): Promise<any> {
    this.cognitoUser = result;
    const idToken = result.signInUserSession.idToken;
    this.token = idToken.jwtToken;
    this.ugId = idToken.payload.ug_id;
    this.ugName = idToken.payload.ug_name;

    // 初めてugOptionを取得する場合のみ通信実施
    if (this.userGroupOptions.length === 0 && !this.userGroupOptions.some(opt => opt.option === 'none')) {
      await this.getUserGroupOptionsAsync();
    }
    // 初めてsmile9UserSettingsを取得する場合のみ通信実施
    if (this.smile9UserSettings.length === 0 && !this.smile9UserSettings.some(opt => opt.ug_id_user === 'none')) {
      await this.getSmile9UserSettingsAsync();
    }

    this.role =  idToken.payload.role;
    this.serviceRole = idToken.payload.service_role;
    this.empStatus = Number(idToken.payload.emp_status);
    this.smile9Role = idToken.payload.smile9_role;

    this.createPayrollKbn = idToken.payload.CreatePayrollKbn;
    this.hojoKbn = idToken.payload.HojoKbn;
    this.hojoGrpCode = Number(idToken.payload.hojo_grp_code);
    this.mainCafeCode = Number(idToken.payload.main_cafe_code);
    this.guestReservationAuth = idToken.payload.GuestReservationAuth;
    this.reducedTaxKbn = idToken.payload.ReducedTaxKbn;
    this.commentInRsv = idToken.payload.CommentInRsv;
    this.multipleRsv = idToken.payload.MultipleRsv;
    this.itadakimasuAteType = idToken.payload.ItadakimasuAteType;

    this.username = result.username;
    this.prefix = idToken.payload.prefix;
    this.coCode = Number(idToken.payload.co_code);
    this.coName = idToken.payload.co_name;
    this.deptCode = Number(idToken.payload.dept_code);
    this.deptName = idToken.payload.dept_name;
    this.empCode = Number(idToken.payload.emp_code);
    this.empName = idToken.payload.emp_name;
    this.versionInToken = idToken.payload.app_client_ver;
    this.appClientName = idToken.payload.app_client_name;
  }

  /** serviceのプロパティからトークン情報を消去 */
  removeTokenInfo(): void {
    this.cognitoUser = null;
    this.token = '';
    this.ugId = '';
    this.ugName = '';

    this.userGroupOptions.length = 0;
    this.smile9UserSettings.length = 0;

    this.role = '';
    this.serviceRole = '';
    this.empStatus = 0;
    this.smile9Role = '';

    this.createPayrollKbn = '';
    this.hojoKbn = '';
    this.hojoGrpCode = 0;
    this.mainCafeCode = 0;
    this.guestReservationAuth = '';
    this.reducedTaxKbn = '';
    this.commentInRsv = '';
    this.multipleRsv = '';
    this.itadakimasuAteType = '';

    this.username = '';
    this.prefix = '';
    this.coCode = 0;
    this.coName = '';
    this.deptCode = 0;
    this.deptName = '';
    this.empCode = 0;
    this.empName = '';

    this.versionInToken = '';
    this.appClientName = '';
    this.isKitchenRsvTerm = false;
    sessionStorage.removeItem('isCompletedInitAuth');
  }

  /** 自動サインアウトを有効にするかのチェック
   * カードサインインからサインインした個人ユーザーなら特定ミリ秒経過後に自動サインアウトするよう、非同期処理を実行。
   */
  public checkToEnableAutoSignOut(): void {
    if (localStorage.getItem('signInUrl') === '/card-signin' &&
        this.smile9Role === SMILE9_ROLES.INDIVIDUAL &&
        !this.isKitchenRsvTerm) {
      this.isKitchenRsvTerm = true;
      this.enableTimeoutSignOut();
    }
  }

  /** 一定時間経過後、強制サインアウトする
   * (カードサインインして個人予約画面を利用する場合のみ有効化)
   */
  private enableTimeoutSignOut() {
    this.disableTimeoutSignOut();
    this.timeoutSignOut = setTimeout(() => {
      // モーダル用の要素, classを消去
      $('body').removeClass('modal-open');
      $('.modal-backdrop').remove();
      const bodyStyle = document.body.style as any;
      if (bodyStyle.removeAttribute) {
        bodyStyle.removeAttribute('padding-right');
      } else {
        bodyStyle.removeProperty('padding-right');
      }
      // ページ遷移するとトースターが全消去されてしまうので、少しウェイトを挟んでからトースター表示する
      setTimeout(() => {
        this.msgServ.warning(MSG.WARNING.TOKEN_EXPIRED2, '', 1000 * 60 * 3);
      }, 3000);
      this.signOut();
    // ↓自動サインアウトまでの待ち時間(ミリ秒指定)
    }, this.availableTimeInCardRsv());
  }

  /** 自動サインアウトまでの待ち時間を取得 */
  private availableTimeInCardRsv(): number {
    const settingValues: string[] = this.getSmile9UserSettingsValues(SMILE9_USER_SETTINGS.AVAILABLE_TIME_IN_CARD_RSV);
    if (settingValues.length >= 1 && !isNaN(Number(settingValues[0]))) {
      const availableTime = 1000 * 60 * Number(settingValues[0]);
      console.log(`available time: ${availableTime}`);
      return availableTime;
    } else {
      // (M)Smile9ユーザー設定で指定がなければ、デフォルトで10分を待ち時間にする。
      const availableTime = 1000 * 60 * 10;
      console.log(`available time: ${availableTime}`);
      return availableTime;
    }
  }

  private disableTimeoutSignOut() {
    clearTimeout(this.timeoutSignOut);
  }

  /** ユーザーグループオプションを非同期で取得。配列で保持。 */
  private async getUserGroupOptionsAsync(): Promise<any> {
    return new Promise(resolve => {
      this.http.request('get', `${SKS_MASTER_API_ENDPOINT}api/AfterSignIn/UserGroupOptions`).subscribe(
        response => {
          const options = response as AuthUserGroupOptions[];
          this.userGroupOptions.length = 0;
          options.forEach(opt => this.userGroupOptions.push(opt));
          if (this.userGroupOptions.length === 0) {
            // 配列のlengthを0にせず、noneという要素をpushすることで、少なくとも１度APIへ問い合わせしたという履歴を残す。ページ遷移時に毎回不要な問い合わせしないための処置。
            this.userGroupOptions.push({option: 'none', option_value: null});
          }
          resolve(true);
        }
      );
    });
  }

  /** smile9ユーザー設定を非同期で取得。配列で保持。 */
  private async getSmile9UserSettingsAsync(): Promise<any> {
    return new Promise(resolve => {
      this.http.request('get', `${SMILE9_API_ENDPOINT}api/AfterSignIn/Smile9UserSettings`).subscribe(
        response => {
          const options = response as Smile9UserSettings[];
          this.smile9UserSettings.length = 0;
          options.forEach(opt => this.smile9UserSettings.push(opt));
          if (this.smile9UserSettings.length === 0) {
            // 配列のlengthを0にせず、noneという要素をpushすることで、少なくとも１度APIへ問い合わせしたという履歴を残す。ページ遷移時に毎回不要な問い合わせしないための処置。
            this.smile9UserSettings.push({ug_id_user: 'none', item: null, value: null});
          }
          resolve(true);
        }
      );
    });
  }

  /** 特定のユーザーグループオプションが特定の値で設定されているかを判定。
   * 例： isSetUgGroup('self_regi', '1') => セルフレジオプションが有効かどうかをチェックする
   * @param {string} ugOption 判定するユーザーグループオプション
   * @param {string} expectUgOptionValue 判定するオプション値(string型なので注意)
   * @returns {boolean} 判定結果
   */
  public isSetUgOption(ugOption: string, expectUgOptionValue: string) {
    return this.userGroupOptions.some(opt => opt.option === ugOption && opt.option_value === expectUgOptionValue);
  }

  public getAllValidUgOptions(optionValue: string): string[] {
    return this.userGroupOptions.map(option => {
      if (option.option_value === optionValue) {
        return option.option;
      }
    });
  }

    /** 特定のSmile9ユーザー設定が特定の値で設定されているかを判定。
   * 例： isSetSmile9UserSettings('allow_search_emp_code', '1') => 社員番号検索が有効かどうかをチェックする
   * @param {string} item 判定する項目名
   * @param {string} value 判定する値(string型なので注意)
   * @returns {boolean} 判定結果
   */
  public isSetSmile9UserSettings(item: string, value: string): boolean {
    return this.smile9UserSettings.some(opt => opt.item === item && opt.value === value);
  }

    /** 特定のSmile9ユーザー設定を取得する。
   * 例： isSetSmile9UserSettings('available_time_in_card_rsv') => カードサインインでの個人予約画面における自動サインアウトまでの時間を取得
   * @param {string} item 取得する項目名
   * @returns {string[]} 取得結果(= (M)Smile9ユーザー設定のvalue)。取得できなかった場合は空配列を返す。
   */
  public getSmile9UserSettingsValues(item: string): string[] {
    const settingsList = this.smile9UserSettings.filter(opt => opt.item === item);
    if (settingsList.length >= 1) {
      return settingsList.map(settings => settings.value);
    } else {
      return [];
    }
  }
}
